import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as CpuImg } from "../../../img/ico-vpc-list-cpu.svg";
import { ReactComponent as MemoryImg } from "../../../img/ico-vpc-list-memory.svg";
import { ReactComponent as StorageImg } from "../../../img/ico-vpc-list-storage.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";

import StorageAdd from "./StorageAdd";
import StorageUpdate from "./StorageUpdate";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";

import { t } from "i18next";
import CustomProgressBar from "../../base/CustomProgressBar";


interface OsdData {
    osd_id: number;
    up_yn: boolean;
    osd_tot_cap_gb: number,
    osd_used_cap_gb: number
}


export default interface StorageData {
    storage_pool_id: string;
    storage_pool_name: string;
    ip_address: string;
    up_yn: boolean;
    location_info: string;
    max_over_subscription_ratio: number;
    multiattach_yn: boolean;
    storage_protocol_type_code: string;
    thin_provisioning_support_yn: boolean;
    storage_pool_total_capacity_gb: number;
    storage_pool_allocated_capacity_gb: number;
    storage_pool_free_capacity_gb: number;
    volume_backend_name: string;
    create_ts: string;
    update_ts: string;
    region: {
        region_id: string;
        region_name: string;
    }
    storage_pool: {
        storage_pool_total_capacity_gb: number;
        storage_pool_allocated_capacity_gb: number;
        storage_pool_free_capacity_gb: number;
        storage_pool_percent: number;
    }
    osds: OsdData[]
}


export interface DetailProps {
    setLoading: Function;
    showSlideModalCb?: Function;
    showPopupModalCb: Function;
    targetId: string;
}



export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "STORAGE_SYNC",
        },
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("STORAGE_NAME_TEXT"),
        accessor: "storage_pool_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("STORAGE_ALLOCATED_SIZE_TEXT"),
        accessor: "storage_pool_allocated_capacity_gb",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value} GiB</div>)
    },
    {
        Header: i18n.t("STORAGE_SIZE_TEXT"),
        accessor: "storage_pool",
        disableSortBy: true,
        style: {
            width: "150px",
            paddingLeft: 20,
        },
        Cell: ({ cell: {value} }) => (
            value.storage_pool_percent < 75 ?
            <div style={className.usageContainer}>
                <div style={className.usageRowContainer}>
                    <StorageImg style={className.resourceImg}/>
                    <div style={className.usageText}>{value.storage_pool_total_capacity_gb}{value.unitText}</div>
                    <div style={className.usageStorageValue}>{value.storage_pool_percent}%</div>
                </div>
                <div style={className.usageRowContainer}>
                    <CustomProgressBar key={901} width={120} height={10} colors={["#5a7ee9", "#f0f3fa"]} percent={value.storage_pool_percent}/>
                </div>
            </div>
            :value.storage_pool_percent >= 75 && value.storage_pool_percent < 90 ?
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <AlertImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <StorageImg style={className.resourceImg}/>
                            <div style={className.usageText}>{value.storage_pool_total_capacity_gb}{value.unitText}</div>
                            <div style={className.usageWarnValue}>{value.storage_pool_percent}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={901} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.storage_pool_percent}/>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <ErrorImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <StorageImg style={className.resourceImg}/>
                            <div style={className.usageText}>{value.storage_pool_total_capacity_gb}{value.unitText}</div>
                            <div style={className.usageWarnValue}>{value.storage_pool_percent}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={901} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.storage_pool_percent}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    },
    {
        Header: i18n.t("OSDs"),
        accessor: "osds",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{display: "flex", alignItems: "center"}}>
                {
                    value.map((osd, idx) => {
                        return (
                        <div style={osd.up_yn ? {...className.osdBox, marginRight: 3} : {...className.osdBox, backgroundColor: "#e6735c", marginRight: 3}} key={idx}>
                            <div style={{...className.normalTextContainer, fontFamily:FONT.BOLD, width: 20, textAlign:"center", color: "#ffffff"}}>{osd.up_yn ? "O" : "X"}</div>
                        </div>
                        )
                    })
                }
            </div>
        )
    },
    {
        Header: i18n.t("TYPE_TEXT"),
        accessor: "storage_protocol_type_code",
        disableSortBy: false,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#3a8344"}}>
            {
            value === "CEPH" ? "Ceph"
            :value === "ISCSI" ? "iSCSI"
            :value === "LOCAL" ? <>{i18n.t("LOCAL_TEXT")}</>
            :value === "FC" ? "FC"
            :<>{i18n.t("UNKNOWN_TEXT")}</>
            }
        </div>)
    },
    {
        Header: i18n.t("HOST_STATUS_TEXT"),
        accessor: "up_yn",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <><StatusStableImg style={className.statusImg}/>Up</> : <><StatusBlockImg style={className.statusImg}/>Down</>
                }
            </div>
        )
    },
    {
        Header: i18n.t("STORAGE_VOLUME_BACKEND_NAME_TEXT"),
        accessor: "volume_backend_name",
        disableSortBy: false,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>{value}</div>
        )
    },
    {
        Header: i18n.t("REGION_TEXT"),
        accessor: "region.region_name",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
];

export const storageAddModalContent = {
    title: i18n.t("STORAGE_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <StorageAdd />,
}

export const storageUpdateModalContent = {
    title: i18n.t("STORAGE_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            deleteButtonYn: false,
            cancelButtonYn: false,
            confirmButtonText: i18n.t("CONFIRM_TEXT")
        },
    ],
    innerComponent: <StorageUpdate />,
}


const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    statusImg: {
        marginRight: 3
    },
    resourceImg: {
        width: 24,
        height: 24
    },
    usageContainer: {
        paddingLeft: 20
    },
    usageRowContainer: {
        width: "120px",
        display: "flex",
        alignItems: "center"
    },
    usageImg: {
        width: "24px",
        height: "24px",
        filter: "opacity(0.5)"
    },
    usageText: {
        fontFamily: FONT.REGULAR,
        fontSize: "10px",
        color: "#8793a3"
    },
    usageStorageValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        color: "#5a7ee9"
    },
    usageWarnValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        color: "#e6735c"
    },
    warnImg: {
        width: 20,
        height: 20
    },
    osdBox: {
        width: 20,
        height: 20,
        borderRadius: 2,
        backgroundColor: "#5a7ee9",
        display: "flex",
        alignItems: "center",
        justifyContents: "center"
    }
}